import React, { lazy, Suspense } from 'react';

const LazyApiList = lazy(() => import('./ApiList'));

const ApiList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyApiList {...props} />
  </Suspense>
);

export default ApiList;
